import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Input, Label } from 'reactstrap';

import { Button } from '../../../components';
import { CloseButton } from '../TestFeedbackModal/styles';
import ConfirmModal from '../../../../components/Modals/confirmModal';
import './styles.css';

export default React.memo((props) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isAgreed, setIsAgreed] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);

  const hideModal = (value) => {
    setIsOpen(false);
    if (value && props.isMobile) return setConfirmModal(true);
    return props.confirm(value);
  };

  return (
    <>
      {confirmModal && (
        <ConfirmModal
          title="Confirmation"
          text="A computer is preferable when taking this test. Do you still want to continue anyway?"
          onConfirm={() => props.confirm(true)}
          onCancel={() => props.confirm(false)}
        />
      )}
      <Modal isOpen={isOpen} className="modal-container">
        <ModalHeader className="test-start-modal-title">Instructions</ModalHeader>
        <CloseButton onClick={() => hideModal(false)}>&times;</CloseButton>
        <ModalBody
          className="test-start-modal-body"
          dangerouslySetInnerHTML={{
            __html: props.children,
          }}
        ></ModalBody>
        <ModalFooter className="test-start-modal-footer">
          <FormGroup onClick={() => setIsAgreed(!isAgreed)} className="checkbox-margin">
            <Input
              className="cursor-pointer"
              type="checkbox"
              checked={isAgreed}
              onChange={(e) => setIsAgreed(e.target.value)}
            />{' '}
            <Label className="cursor-pointer">I have read the instructions</Label>
          </FormGroup>
          <Button
            disabled={!isAgreed}
            small
            primaryBlue
            primaryGreenBorder
            removeMargin
            buttonClick={() => hideModal(true)}
          >
            Start
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
});
